import { RawIconBase, type RawIconProps } from './icons/RawIconBase';

export function InstapaperIcon(props: RawIconProps) {
  return (
    <RawIconBase badge={{ scale: 0.5 }} color="#1F1F1F" {...props}>
      <path d="M14.766 20.259c0 1.819.271 2.089 2.934 2.292V24H6.301v-1.449c2.666-.203 2.934-.473 2.934-2.292V3.708c0-1.784-.27-2.089-2.934-2.292V0h11.398v1.416c-2.662.203-2.934.506-2.934 2.292v16.551z" />
    </RawIconBase>
  );
}
